import { isSameDomain } from '../utils.js';

export default function () {
  const widgetName = 'cardWidgetQuickLinks';
  const widgetOpts = cardWidgetQuickLinksOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        removeUnusedTags({ widgetName });
        isSameDomain(data, widgetName);
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['title'],
    maxItemsVisible: 3,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    textOverImage: false,
  });
}

// remove buttonwrap if empty
function removeUnusedTags({ widgetName }) {
  $(`#${widgetName}`).find('.buttonwrap').remove();
}
